import TreeMap from 'd3vue/components/TreeMap.vue'
import { asTree, buildCropFunction, valueAsNumber } from '../dataFilter'
import { toScale } from '../colors'
import config from '../config'
import api from '../api'

export default {
  id: 'treemap',
  label: 'Carte proportionnelle',
  component: TreeMap,
  dimensions: 1,
  multipleMeasure: () => false,
  adaptater (data, vue) {
    vue.buildProps({
      colorScale: vue.colorScheme ? toScale(vue.colorScheme) : config.colorScale
    })
    let result = asTree(data, {
      measure: api.measure.name(vue.measure[0]),
      typed: d => valueAsNumber(d)
    })

    if (result.children.every(d => !d.children || !d.children.length)) {
      result.children = buildCropFunction(d => d.count || 0, vue)(result.children)
    }

    return result
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/TreeMap.js